import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"home-open, house"} maskId="square-filled-radius-0-stroke-1-IconHomeOpen"><path d="M12 1.35815L3 8.60312V21H10V15H14V21H21V8.60312L12 1.35815Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHomeOpen;
